import React, { useEffect, useMemo, useState } from "react";
import { Center, Spinner, Text } from "@chakra-ui/react";
import Papa from "papaparse";
import { useRecoilValue } from "recoil";
// import { userState } from "states/recoil"; // if you need it
import { sheetURLSelector } from "states/recoil";

import ChoroplethMap from "./MapChartChorpelet";

import geoProvPapua from "../../assets/geoJSON/goejson_papua.json";
import geoProvPapuaTengah from "../../assets/geoJSON/geojson_papuatengah.json";
import geoProvPapuaPegunungan from "../../assets/geoJSON/goejson_papuapegunungan.json";
import geoProvPapuaSelatan from "../../assets/geoJSON/goejson_papuaselatan.json";
import geoProvPapuaBarat from "../../assets/geoJSON/goejson_papuabarat.json";
import geoProvPapuaBaratDaya from "../../assets/geoJSON/goejson_papuabaratdaya.json";
import geoAllProvinsi from "../../assets/geoJSON/goejson_allpapua.json";

// --- STATIC base data (defaults; will be overwritten by sheet)
const dataProvPapua = [
  { alias: "Kab. Sarmi", id: "sarmi", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kab. Kepulauan Yapen",
    id: "kepulauan-yapen",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Waropen", id: "waropen", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kota Jayapura",
    id: "kota-jayapura",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  {
    alias: "Kab. Jayapura",
    id: "kabupaten-jayapura",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Supiori", id: "supiori", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kab. Mamberamo Raya",
    id: "mamberamo-raya",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Keerom", id: "keerom", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kab. Biak Numfor",
    id: "biak-numfor",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
];

const dataProvPapuaTengah = [
  { alias: "Kab. Dogiyai", id: "dogiyai", value: 0, pagu: 0, realisasi: 0 },
  { alias: "Kab. Deiyai", id: "deiyai", value: 0, pagu: 0, realisasi: 0 },
  { alias: "Kab. Nabire", id: "nabire", value: 0, pagu: 0, realisasi: 0 },
  { alias: "Kab. Mimika", id: "mimika", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kab. Intan Jaya",
    id: "intan-jaya",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Puncak", id: "puncak", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kab. Puncak Jaya",
    id: "puncak-jaya",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Paniai", id: "paniai", value: 0, pagu: 0, realisasi: 0 },
];

const dataProvPapuaPegunungan = [
  { alias: "Kab. Yalimo", id: "yalimo", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kab. Mamberamo Tengah",
    id: "mamberamo-tengah",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  {
    alias: "Kab. Pegunungan Bintang",
    id: "pegunungan-bintang",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Yahukimo", id: "yahukimo", value: 0, pagu: 0, realisasi: 0 },
  { alias: "Kab. Nduga", id: "nduga", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kab. Lanny Jaya",
    id: "lanny-jaya",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  {
    alias: "Kab. Jayawijaya",
    id: "jayawijaya",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Tolikara", id: "tolikara", value: 0, pagu: 0, realisasi: 0 },
];

const dataProvPapuaSelatan = [
  { alias: "Kab. Asmat", id: "asmat", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kab. Boven Digoel",
    id: "boven-digoel",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Mappi", id: "mappi", value: 0, pagu: 0, realisasi: 0 },
  { alias: "Kab. Merauke", id: "merauke", value: 0, pagu: 0, realisasi: 0 },
];

const dataProvPapuaBarat = [
  {
    alias: "Kab. Manokwari Selatan",
    id: "manokwari-selatan",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Manokwari", id: "manokwari", value: 0, pagu: 0, realisasi: 0 },
  { alias: "Kab. Fakfak", id: "fak-fak", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kab. Teluk Bintuni",
    id: "teluk-bintuni",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  {
    alias: "Kab. Pegunungan Arfak",
    id: "pegunungan-arfak",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  {
    alias: "Kab. Teluk Wondama",
    id: "teluk-wondama",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Kaimana", id: "kaimana", value: 0, pagu: 0, realisasi: 0 },
];

const dataProvPapuaBaratDaya = [
  {
    alias: "Kab. Raja Ampat",
    id: "raja-ampat",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kab. Tambrauw", id: "tambrauw", value: 0, pagu: 0, realisasi: 0 },
  { alias: "Kab. Maybrat", id: "maybrat", value: 0, pagu: 0, realisasi: 0 },
  {
    alias: "Kab. Sorong Selatan",
    id: "sorong-selatan",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  {
    alias: "Kab. Sorong",
    id: "kabupaten-sorong",
    value: 0,
    pagu: 0,
    realisasi: 0,
  },
  { alias: "Kota Sorong", id: "kota-sorong", value: 0, pagu: 0, realisasi: 0 },
];

// Province slug -> config
const PROVINCE_CONFIG = {
  papua: { geojson: geoProvPapua, data: dataProvPapua },
  "papua-tengah": { geojson: geoProvPapuaTengah, data: dataProvPapuaTengah },
  "papua-pegunungan": {
    geojson: geoProvPapuaPegunungan,
    data: dataProvPapuaPegunungan,
  },
  "papua-selatan": { geojson: geoProvPapuaSelatan, data: dataProvPapuaSelatan },
  "papua-barat": { geojson: geoProvPapuaBarat, data: dataProvPapuaBarat },
  "papua-barat-daya": {
    geojson: geoProvPapuaBaratDaya,
    data: dataProvPapuaBaratDaya,
  },
  "semua-provinsi": {
    geojson: geoAllProvinsi, // will be handled specially
    data: [
      ...dataProvPapua,
      ...dataProvPapuaTengah,
      ...dataProvPapuaPegunungan,
      ...dataProvPapuaSelatan,
      ...dataProvPapuaBarat,
      ...dataProvPapuaBaratDaya,
    ],
  },
};

// ——— Helpers
const slugify = (s) => (s || "").toLowerCase().replace(/\s+/g, "-");

// normalize for matching "NM PEMDA" to your aliases
const normalizePemda = (s) =>
  (s || "")
    .toUpperCase()
    .replace(/KABUPATEN|KAB\.?|KOTA/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/[^\p{L}\p{N}\s-]/gu, "")
    .replace(/\s+/g, " ");

// parse number like "1.234,56" or "1,234.56" or "1234"
const toNumber = (raw) => {
  if (raw == null) return 0;
  const s = String(raw).trim();
  if (!s) return 0;
  const hasCommaDecimal = /,\d{1,2}$/.test(s);
  let cleaned = s.replace(/[^0-9,.\-]/g, "");
  if (hasCommaDecimal) {
    cleaned = cleaned.replace(/\./g, "").replace(",", ".");
  } else {
    cleaned = cleaned.replace(/,/g, "");
  }
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : 0;
};

export default function MapChart() {
  const [isLoading, setIsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [configKey, setConfigKey] = useState(null); // <- no TS generics in JS
  const [rows, setRows] = useState([]); // <- no TS generics in JS

  const sheetURL = useRecoilValue(sheetURLSelector);

  // 1) Read province from localStorage
  useEffect(() => {
    let mounted = true;
    (async () => {
      setIsLoading(true);
      try {
        if (typeof window === "undefined") {
          if (mounted) setErrorMsg("Tidak dapat mengambil data");
          return;
        }
        const raw = localStorage.getItem("userInfo");
        if (!raw) {
          if (mounted) setErrorMsg("Tidak dapat mengambil data");
          return;
        }
        let provinceSlug = "papua-barat-daya";
        try {
          const parsed = JSON.parse(raw);
          if (parsed?.province) provinceSlug = slugify(parsed.province);
        } catch {
          if (mounted) setErrorMsg("Tidak dapat mengambil data");
          return;
        }
        if (mounted) setConfigKey(provinceSlug);
      } finally {
        if (mounted) setIsLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  // 2) Fetch the sheet and parse
  useEffect(() => {
    let mounted = true;
    if (!sheetURL) return;
    setIsLoading(true);

    fetch(sheetURL)
      .then((res) => res.text())
      .then((text) => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            if (!mounted) return;
            setRows(Array.isArray(results.data) ? results.data : []);
            setIsLoading(false);
          },
          error: () => {
            if (!mounted) return;
            setErrorMsg("Tidak dapat mengambil data");
            setIsLoading(false);
          },
        });
      })
      .catch(() => {
        if (!mounted) return;
        setErrorMsg("Tidak dapat mengambil data");
        setIsLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [sheetURL]);

  const selected = useMemo(() => {
    if (!configKey) return null;
    return PROVINCE_CONFIG[configKey] ?? null;
  }, [configKey]);

  // 3) Aggregate pagu & realisasi per NM PEMDA, then map onto selected.data by alias
  const dataFilled = useMemo(() => {
    if (!selected?.data || selected.data.length === 0) return null;

    const agg = new Map(); // key: normalized NM PEMDA -> { pagu, realisasi }

    for (const r of rows) {
      const nm = normalizePemda(r?.["NM PEMDA"]);
      if (!nm) continue;

      const pagu = toNumber(r?.["PAGU ALOKASI"]);
      const realisasi = toNumber(r?.["REALISASI"]);

      const prev = agg.get(nm) || { pagu: 0, realisasi: 0 };
      prev.pagu += pagu;
      prev.realisasi += realisasi;
      agg.set(nm, prev);
    }

    const normalizeAliasForMatch = (alias) => normalizePemda(alias);

    const filled = selected.data.map((d) => {
      const key = normalizeAliasForMatch(d.alias);
      const hit = agg.get(key);

      const pagu = hit?.pagu ?? 0;
      const realisasi = hit?.realisasi ?? 0;
      const persen = pagu > 0 ? (realisasi / pagu) * 100 : 0;

      return {
        ...d,
        pagu,
        realisasi,
        value: Math.round(persen), // choropleth value = persentase
        persentase: persen,
      };
    });

    return filled;
  }, [rows, selected]);

  // UI states
  if (isLoading) {
    return (
      <Center w="100%" h="500px">
        <Spinner size="xl" color="blue.500" />
      </Center>
    );
  }

  if (errorMsg) {
    return (
      <Center w="100%" h="500px">
        <Text>{errorMsg}</Text>
      </Center>
    );
  }

  if (!selected || !dataFilled || dataFilled.length === 0) {
    return (
      <Center w="100%" h="500px">
        <Text>Tidak ada data yang ditampilkan.</Text>
      </Center>
    );
  }

  return <ChoroplethMap geojson={selected.geojson} data={dataFilled} />;
}
